import UniversalWebView from '@/components/UniversalWebView'
import { getAuthToken } from '@/lib/api/authToken'
import { fetchCurrentUserThunk } from '@/redux/slices/currentUserSlice'
import { getUsageAndBalanceThunk } from '@/redux/slices/usageAndBalanceSlice'
import { useAppDispatch } from '@/redux/store'
import { router, useLocalSearchParams } from 'expo-router'
import { get } from 'lodash-es'
import { useCallback, useMemo } from 'react'

export default function Cashier() {
  const dispatch = useAppDispatch()
  const searchParams = useLocalSearchParams<{ cashierParams?: string; code?: string }>()

  const uri = useMemo(() => {
    const token = getAuthToken()
    let url = `${process.env.EXPO_PUBLIC_NEXT_BASE_URL}/m/payment/cashier?m_t=${token}`

    if (searchParams.cashierParams) {
      url += `&cashierParams=${searchParams.cashierParams}`
    }
    if (searchParams.code) {
      url += `&code=${encodeURIComponent(searchParams.code)}`
    }

    return url
  }, [searchParams.cashierParams, searchParams.code])

  const handleMessage = useCallback(
    (data: { event: string; details: unknown }) => {
      if (data.event === 'WX_PAY') {
        const { charge, orderNo } = data.details as {
          charge: unknown
          orderNo: string
          channel: string
        }
        const params = {
          charge,
          callbackUrl: `/profile/pay_result?order=${orderNo}&result=success`,
          errorCallbackUrl: `/profile/pay_result?order=${orderNo}&result=failed`,
        }
        sessionStorage.setItem('wx_pay_params', btoa(encodeURIComponent(JSON.stringify(params))))
        window.location.href = '/pay/index.html'
        return
      }

      if (data.event === 'PAY_RESULT') {
        const status = get(data.details, 'status')
        if (status === 'success') {
          dispatch(fetchCurrentUserThunk())
          dispatch(getUsageAndBalanceThunk())
        }

        router.replace('/(system)/profile' as any)
      }
    },
    [dispatch]
  )

  return (
    <UniversalWebView
      source={{ uri }}
      style={{ backgroundColor: '#f3f4f6' }}
      onMessage={handleMessage}
      className="flex-1"
    />
  )
}
